import React,{ Component, Fragment } from 'react'
import routes from './route';
import { Provider } from 'react-redux';
import {store} from './store';

import ReactSVG from 'react-svg'
const svgIcons = require( './static/image/svg-icons.svg');

export default class Global extends Component<any, any>{
    componentDidMount() {  
    }
    render(){
        return (
            <Fragment>
                <ReactSVG id="ins-svg" className="ins-svg" src={ svgIcons } style={{display: 'none'}}/>
                <Provider store={store} >
                    {routes}
                </Provider>
            </Fragment>
        )
    }

}
